import { IAbstractInitialState } from "../../types/common";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IPlaylistByUrl } from "../../types/playlists";
import { playlistCards } from "../../api/asyncThuncks/playlistsCards";

interface IInitialState extends IAbstractInitialState {
  playlistByUrl: IPlaylistByUrl | null;
  trackNumber: number;
  nextTrackAuto: boolean;
  stopPlayingPlaylist: boolean;
  playingPlaylistId: string | null;
}

const initialState: IInitialState = {
  loading: "idle",
  playlistByUrl: null,
  trackNumber: 0,
  nextTrackAuto: false,
  stopPlayingPlaylist: true,
  playingPlaylistId: null,
  error: "",
};

const playlistsSlice = createSlice({
  name: "playlistsSlice",
  initialState,
  reducers: {
    setSettingPlaylistTrackNumber(state, { payload }: PayloadAction<number>) {
      state.trackNumber = payload;
    },
    setSettingPlaylistPlaying(state, { payload }: PayloadAction<boolean>) {
      state.nextTrackAuto = payload;
    },
    setSettingPlayingPlaylistId(state, { payload }: PayloadAction<string>) {
      state.playingPlaylistId = payload;
    },
    setSettingStopPlayingPlaylist(state, { payload }: PayloadAction<boolean>) {
      state.stopPlayingPlaylist = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(playlistCards.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(playlistCards.fulfilled, (state, { payload }) => {
        state.loading = "idle";
        state.playlistByUrl = { ...payload };
        state.playingPlaylistId = payload.title;
      })
      .addCase(playlistCards.rejected, (state, { error }) => {
        if (error.message) state.error = error.message;
        state.loading = "failed";
      });
  },
});

export const selectPlaylists = (state: RootState): IInitialState =>
  state.playlists;

export const {
  setSettingPlaylistTrackNumber,
  setSettingPlaylistPlaying,
  setSettingPlayingPlaylistId,
  setSettingStopPlayingPlaylist,
} = playlistsSlice.actions;

export default playlistsSlice.reducer;
